<template>
  <div class="page-container mine-page">
    <!-- 顶部 profile 卡片 -->
    <div class="profile-card">
      <div class="profile-bg"></div>
      <div class="profile-body">
        <div class="avatar-box">
          <el-avatar :size="68" :src="userInfo.avatar" icon="el-icon-user-solid" />
        </div>
        <div class="profile-meta">
          <div class="name-row">
            <span class="profile-name">{{ userInfo.name || '主账号管理员' }}</span>
            <el-tag size="mini" type="danger" effect="dark">{{ userInfo.role || '主账号' }}</el-tag>
            <el-tag v-if="entStatus === 'certified'" size="mini" type="success" effect="plain">
              <i class="el-icon-check"></i> 已认证
            </el-tag>
          </div>
          <div class="profile-sub">
            <i class="el-icon-mobile-phone"></i>
            <span>{{ userInfo.phone || '尚未绑定手机' }}</span>
            <span class="divider">|</span>
            <i class="el-icon-user"></i>
            <span>{{ userInfo.name || '管理员' }}</span>
          </div>
        </div>
        <el-button size="small" plain class="profile-edit" @click="switchTab('settings'); jumpToAnchor('profile')">
          <i class="el-icon-edit"></i> 编辑资料
        </el-button>
      </div>
    </div>

    <!-- 统计卡 -->
    <div class="stat-row">
      <div class="stat-card"><div class="sc-num" style="color:#165dff">{{ stats.bound }}</div><div class="sc-label">已绑定设备</div></div>
      <div class="stat-card"><div class="sc-num" style="color:#f53f3f">{{ stats.alertToday }}</div><div class="sc-label">今日告警</div></div>
      <div class="stat-card"><div class="sc-num" style="color:#00b42a">{{ stats.onlineRate }}%</div><div class="sc-label">设备在线率</div></div>
    </div>

    <!-- 主内容（多 tab） -->
    <el-tabs v-model="tab" class="mine-tabs">
      <!-- ============ 公司成员 ============ -->
      <el-tab-pane label="公司成员" name="sub">
        <div class="toolbar">
          <el-button v-if="hasPermission('mine_sub_add')" type="success" icon="el-icon-plus" @click="openAdd">新增子账号</el-button>
          <span class="hint">仅展示本公司成员（主账号 + 子账号）</span>
        </div>
        <el-table :data="subs" border v-loading="loading" empty-text="暂无成员" height="100%">
          <el-table-column prop="name" label="成员" min-width="150" />
          <el-table-column label="角色" width="110">
            <template slot-scope="scope">
              <el-tag :type="scope.row.role === '主账号' ? 'danger' : 'info'" size="mini">{{ scope.row.role }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号" min-width="140" />
          <el-table-column prop="remark" label="备注" min-width="140" />
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.active ? 'success' : 'info'" size="mini">{{ scope.row.active ? '启用' : '停用' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" fixed="right">
            <template slot-scope="scope">
              <template v-if="!scope.row.isSelf">
                <el-link v-if="hasPermission('mine_sub_edit')" type="primary" @click="openEdit(scope.row)">编辑</el-link>
                <el-link v-if="hasPermission('mine_sub_delete')" type="danger" @click="removeRow(scope.row)">删除</el-link>
              </template>
              <span v-else class="self-tip">本人</span>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <!-- ============ 企业认证 ============ -->
      <el-tab-pane label="企业认证" name="enterprise">
        <el-form label-width="130px" class="ent-form" v-loading="entLoading">
          <el-form-item label="认证状态">
            <el-tag :type="statusType" size="mini">{{ statusText }}</el-tag>
          </el-form-item>
          <el-form-item label="企业名称">
            <el-input v-model="entForm.name" placeholder="请输入企业名称" />
          </el-form-item>
          <el-form-item label="统一社会信用代码">
            <el-input v-model="entForm.creditCode" placeholder="请输入统一社会信用代码" />
          </el-form-item>
          <el-form-item label="联系人">
            <el-input v-model="entForm.contact" placeholder="请输入联系人姓名" />
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input v-model="entForm.phone" placeholder="请输入联系电话" />
          </el-form-item>
          <el-form-item label="营业执照号">
            <el-input v-model="entForm.licenseNo" placeholder="请输入营业执照号" />
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="entForm.remark" type="textarea" :rows="2" placeholder="选填" />
          </el-form-item>
          <el-form-item>
            <el-button v-if="hasPermission('enterprise_edit')" type="primary" :loading="entSaving" @click="saveEnt">提交认证</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- ============ 设置（基本/密码/通知/关于） ============ -->
      <el-tab-pane label="设置" name="settings">
        <div class="settings-wrap">
          <!-- 基本信息 -->
          <div class="set-section" id="anchor-profile">
            <div class="set-section-title"><i class="el-icon-user"></i> 基本信息</div>
            <div class="set-card">
              <div class="set-row">
                <span class="set-label">头像</span>
                <el-upload class="avatar-uploader" :show-file-list="false" :auto-upload="false" :on-change="onAvatarChange">
                  <el-avatar :size="44" :src="form.avatar" icon="el-icon-user-solid" />
                </el-upload>
                <span class="set-hint">点击更换</span>
              </div>
              <div class="set-row">
                <span class="set-label">昵称</span>
                <el-input v-model="form.name" size="small" maxlength="20" show-word-limit class="set-input" />
              </div>
              <div class="set-row">
                <span class="set-label">性别</span>
                <el-radio-group v-model="form.gender" size="small">
                  <el-radio-button label="男">男</el-radio-button>
                  <el-radio-button label="女">女</el-radio-button>
                  <el-radio-button label="保密">保密</el-radio-button>
                </el-radio-group>
              </div>
              <div class="set-row">
                <span class="set-label">个性签名</span>
                <el-input v-model="form.bio" size="small" maxlength="50" show-word-limit placeholder="一句话介绍自己" class="set-input" />
              </div>
              <div class="set-row">
                <span class="set-label">手机号</span>
                <span class="set-value">{{ userInfo.phone || '尚未绑定' }}</span>
                <el-button size="mini" plain @click="$message.info('手机号授权在微信小程序中可用')">去授权</el-button>
              </div>
            </div>
          </div>

          <!-- 账号安全 -->
          <div class="set-section" id="anchor-security">
            <div class="set-section-title"><i class="el-icon-lock"></i> 账号安全</div>
            <div class="set-card">
              <div class="set-row clickable" @click="pwdShow = true">
                <span class="set-label">修改密码</span>
                <span class="set-value muted">建议 6-20 位字母 + 数字</span>
                <i class="el-icon-arrow-right set-arrow"></i>
              </div>
              <div class="set-row clickable" @click="$message.info('微信小程序中可一键重新授权')">
                <span class="set-label">重新授权隐私协议</span>
                <i class="el-icon-arrow-right set-arrow"></i>
              </div>
              <div class="set-row clickable" @click="openPrivacy">
                <span class="set-label">查看隐私政策</span>
                <i class="el-icon-arrow-right set-arrow"></i>
              </div>
            </div>
          </div>

          <!-- 通知级别 -->
          <div class="set-section" id="anchor-notify">
            <div class="set-section-title">
              <i class="el-icon-bell"></i> 通知级别
              <span class="set-section-sub">选择需要接收的告警级别</span>
            </div>
            <div class="set-card">
              <div v-for="lv in notifyLevels" :key="lv.level" class="lv-row" @click="toggleLevel(lv.level)">
                <div class="lv-dot" :style="{ background: lv.color }">{{ lv.level }}</div>
                <div class="lv-meta">
                  <div class="lv-label">{{ lv.label }}</div>
                  <div class="lv-desc">{{ lv.desc }}</div>
                </div>
                <div class="lv-check" :class="{ on: isSelected(lv.level) }">
                  <i v-if="isSelected(lv.level)" class="el-icon-check"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- 订阅消息（web 端仅展示，后端推送） -->
          <div class="set-section">
            <div class="set-section-title"><i class="el-icon-message"></i> 订阅消息</div>
            <div class="set-card">
              <div v-for="s in subscriptions" :key="s.key" class="sub-row">
                <div class="sub-meta">
                  <div class="sub-name">{{ s.name }}</div>
                  <div class="sub-desc">{{ s.desc }}</div>
                </div>
                <el-button :type="s.subscribed ? 'success' : 'primary'" :plain="!s.subscribed" size="mini" @click="toggleSub(s)">
                  <i :class="s.subscribed ? 'el-icon-check' : 'el-icon-plus'"></i>
                  {{ s.subscribed ? '已订阅' : '订阅' }}
                </el-button>
              </div>
            </div>
          </div>

          <!-- 关于 -->
          <div class="set-section">
            <div class="set-section-title"><i class="el-icon-info"></i> 关于</div>
            <div class="set-card">
              <div class="set-row clickable" @click="aboutShow = true">
                <span class="set-label">关于我们</span>
                <span class="set-value muted">哨兵安全监控 · 杭州众地科技</span>
                <i class="el-icon-arrow-right set-arrow"></i>
              </div>
              <div class="set-row clickable" @click="$message.success('感谢您的反馈')">
                <span class="set-label">意见反馈</span>
                <i class="el-icon-arrow-right set-arrow"></i>
              </div>
              <div class="set-row">
                <span class="set-label">版本号</span>
                <span class="set-value muted">V1.2.3 · 构建 {{ buildTime }}</span>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 修改密码弹窗 -->
    <el-dialog title="修改密码" :visible.sync="pwdShow" width="440px" @close="resetPwd">
      <el-form label-width="100px" size="small">
        <el-form-item label="当前密码"><el-input v-model="pwdForm.old" type="password" show-password /></el-form-item>
        <el-form-item label="新密码"><el-input v-model="pwdForm.new" type="password" show-password placeholder="6-20位字母+数字" /></el-form-item>
        <el-form-item label="确认密码"><el-input v-model="pwdForm.confirm" type="password" show-password /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="pwdShow = false">取消</el-button>
        <el-button type="primary" :loading="pwdSaving" @click="changePwd">确认修改</el-button>
      </span>
    </el-dialog>

    <!-- 隐私政策 -->
    <el-dialog title="隐私政策" :visible.sync="privacyShow" width="560px">
      <div class="privacy-text">
        <p>我们重视您的隐私。本平台仅收集为您提供安全监控服务所必需的信息，包括：账号信息、设备绑定数据、告警推送偏好。</p>
        <p>我们承诺：</p>
        <ul>
          <li>不会将您的数据出售或出租给任何第三方</li>
          <li>采用行业标准加密技术保护数据传输与存储</li>
          <li>您可随时通过设置页修改/删除个人偏好</li>
          <li>您可联系客服申请导出或彻底删除账号</li>
        </ul>
        <p class="muted">最后更新：2026-08-18</p>
      </div>
    </el-dialog>

    <!-- 关于我们 -->
    <el-dialog title="" :visible.sync="aboutShow" width="380px" custom-class="about-dialog">
      <div class="about">
        <div class="about-logo"><i class="el-icon-data-analysis"></i></div>
        <div class="about-name">哨兵安全监控</div>
        <div class="about-text">专业的物联网设备监控管理平台，<br>为您的设备安全保驾护航。</div>
        <div class="about-meta">V1.2.3 · 杭州众地科技有限公司</div>
        <el-button type="primary" round class="about-btn" @click="aboutShow = false">确定</el-button>
      </div>
    </el-dialog>

    <!-- 退出登录 -->
    <el-dialog title="退出登录" :visible.sync="logoutShow" width="360px" :show-close="false">
      <div style="text-align:center;color:#86909c;padding:8px 0">退出后将无法查看设备监控数据</div>
      <span slot="footer">
        <el-button @click="logoutShow = false">取消</el-button>
        <el-button type="danger" @click="doLogout">确认退出</el-button>
      </span>
    </el-dialog>

    <!-- 子账号编辑（保留） -->
    <el-dialog :title="subTitle" :visible.sync="subShow" width="440px" @close="resetSub">
      <el-form label-width="90px">
        <el-form-item label="账号名称"><el-input v-model="subForm.name" placeholder="子账号名称" /></el-form-item>
        <el-form-item label="手机号"><el-input v-model="subForm.phone" placeholder="手机号" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="subForm.remark" type="textarea" :rows="2" placeholder="选填" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="subShow = false">取消</el-button>
        <el-button type="primary" :loading="subSaving" @click="saveSub">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSubAccounts, createSubAccount, updateSubAccount, deleteSubAccount,
  getEnterprise, submitEnterprise
} from '@/api/sentinel'

const LS_KEY = 'mm_settings_v1'

export default {
  name: 'MineIndex',
  data() {
    return {
      tab: 'sub',
      // 公司成员
      subs: [],
      loading: false,
      subShow: false,
      subTitle: '新增子账号',
      subSaving: false,
      subForm: { id: 0, name: '', phone: '', remark: '' },
      // 企业认证
      entForm: { status: 'none', name: '', creditCode: '', contact: '', phone: '', licenseNo: '', remark: '' },
      entLoading: false,
      entSaving: false,
      // 设置
      form: { avatar: '', name: '', gender: '保密', bio: '' },
      pwdShow: false,
      pwdSaving: false,
      pwdForm: { old: '', new: '', confirm: '' },
      privacyShow: false,
      aboutShow: false,
      logoutShow: false,
      buildTime: '2026-08-26',
      // 通知级别（P0-P7）
      notifyLevels: [
        { level: 'P0', label: '紧急', desc: '设备离线、碰撞、起火等', color: '#F53F3F' },
        { level: 'P1', label: '严重', desc: '设备严重故障，需立即处理', color: '#FF7D00' },
        { level: 'P2', label: '重要', desc: '设备重要告警', color: '#FFB400' },
        { level: 'P3', label: '一般', desc: '一般运行告警', color: '#165DFF' },
        { level: 'P4', label: '提醒', desc: '设备状态变化提醒', color: '#00B42A' },
        { level: 'P5', label: '系统', desc: '系统类通知', color: '#722ED1' },
        { level: 'P6', label: '运营', desc: '运营活动通知', color: '#EB0AA4' },
        { level: 'P7', label: '其他', desc: '其他通知', color: '#86909C' }
      ],
      selectedLevels: ['P0', 'P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7'],
      // 订阅
      subscriptions: [
        { key: 'offline', name: '设备离线提醒', desc: '设备掉线时立即通知', subscribed: false },
        { key: 'fault', name: '故障告警通知', desc: '设备发生故障时通知', subscribed: false },
        { key: 'report', name: '每日数据报告', desc: '每日推送设备运行日志', subscribed: false },
        { key: 'system', name: '系统维护通知', desc: '系统升级与维护提醒', subscribed: false }
      ],
      // 统计
      stats: { bound: 0, alertToday: 0, onlineRate: 0 }
    }
  },
  computed: {
    userInfo() { return this.$store.state.userInfo || {} },
    statusType() {
      return this.entForm.status === 'certified' ? 'success'
        : this.entForm.status === 'pending' ? 'warning' : 'info'
    },
    statusText() {
      return this.entForm.status === 'certified' ? '已认证'
        : this.entForm.status === 'pending' ? '待审核' : '未认证'
    },
    entStatus() { return this.entForm.status }
  },
  watch: {
    '$route.query.tab'(v) {
      if (v && ['sub', 'enterprise', 'settings'].includes(v)) this.tab = v
    }
  },
  mounted() {
    this.loadSubs()
    this.loadEnt()
    this.loadSettings()
    this.loadStats()
    // 接收从下拉菜单跳过来的 tab 参数
    const t = this.$route.query.tab
    if (t && ['sub', 'enterprise', 'settings'].includes(t)) this.tab = t
  },
  methods: {
    hasPermission(k) { return this.$store.getters.hasPermission(k) },
    /* ---------- 公司成员 ---------- */
    loadSubs() {
      this.loading = true
      const self = this.$store.state.userInfo || {}
      const selfRow = { id: 'self', name: self.name || '主账号', phone: self.phone || '', remark: '公司主账号', active: true, role: '主账号', isSelf: true }
      getSubAccounts().then(res => {
        if (res.code === 200) {
          const list = (res.data && res.data.list) || []
          const subs = list.map(r => ({ ...r, role: '子账号', isSelf: false }))
          this.subs = [selfRow, ...subs]
        } else {
          this.subs = [selfRow]
        }
      }).catch(() => { this.subs = [selfRow] }).finally(() => { this.loading = false })
    },
    openAdd() {
      this.subTitle = '新增子账号'
      this.subForm = { id: 0, name: '', phone: '', remark: '' }
      this.subShow = true
    },
    openEdit(row) {
      this.subTitle = '编辑子账号'
      this.subForm = { id: row.id, name: row.name, phone: row.phone, remark: row.remark }
      this.subShow = true
    },
    resetSub() { this.subForm = { id: 0, name: '', phone: '', remark: '' } },
    saveSub() {
      if (!this.subForm.name) return this.$message.warning('请输入账号名称')
      if (!this.subForm.phone) return this.$message.warning('请输入手机号')
      this.subSaving = true
      const payload = { name: this.subForm.name, phone: this.subForm.phone, remark: this.subForm.remark }
      const req = this.subForm.id ? updateSubAccount(this.subForm.id, payload) : createSubAccount(payload)
      req.then(res => {
        if (res.code === 200) { this.$message.success('保存成功'); this.subShow = false; this.loadSubs() }
      }).finally(() => { this.subSaving = false })
    },
    removeRow(row) {
      this.$confirm(`确认删除子账号「${row.name}」？`, '提示', { type: 'warning' }).then(() => {
        deleteSubAccount(row.id).then(res => {
          if (res.code === 200) { this.$message.success('已删除'); this.loadSubs() }
        })
      }).catch(() => {})
    },
    /* ---------- 企业认证 ---------- */
    loadEnt() {
      this.entLoading = true
      getEnterprise().then(res => {
        if (res.code === 200 && res.data) {
          const d = res.data
          this.entForm = { status: d.status || 'none', name: d.name || '', creditCode: d.creditCode || '', contact: d.contact || '', phone: d.phone || '', licenseNo: d.licenseNo || '', remark: d.remark || '' }
        }
      }).finally(() => { this.entLoading = false })
    },
    saveEnt() {
      if (!this.entForm.name) return this.$message.warning('请输入企业名称')
      this.entSaving = true
      submitEnterprise({
        companyName: this.entForm.name, creditCode: this.entForm.creditCode,
        contactName: this.entForm.contact, contactPhone: this.entForm.phone,
        licenseNo: this.entForm.licenseNo, remark: this.entForm.remark
      }).then(res => {
        if (res.code === 200) { this.$message.success('已提交，等待审核'); this.loadEnt() }
      }).finally(() => { this.entSaving = false })
    },
    /* ---------- 设置 ---------- */
    loadSettings() {
      try {
        const ls = localStorage.getItem(LS_KEY)
        if (ls) {
          const s = JSON.parse(ls)
          if (s.form) this.form = { ...this.form, ...s.form }
          if (Array.isArray(s.selectedLevels) && s.selectedLevels.length) this.selectedLevels = s.selectedLevels
          if (Array.isArray(s.subscriptions) && s.subscriptions.length) {
            this.subscriptions = this.subscriptions.map(x => ({ ...x, subscribed: !!s.subscriptions.find(y => y.key === x.key && y.subscribed) }))
          }
        }
      } catch (e) {}
    },
    persistSettings() {
      const payload = { form: this.form, selectedLevels: this.selectedLevels, subscriptions: this.subscriptions.map(s => ({ key: s.key, subscribed: s.subscribed })) }
      localStorage.setItem(LS_KEY, JSON.stringify(payload))
    },
    onAvatarChange(file) {
      const reader = new FileReader()
      reader.onload = e => { this.form.avatar = e.target.result; this.persistSettings() }
      reader.readAsDataURL(file.raw)
    },
    isSelected(level) { return this.selectedLevels.indexOf(level) >= 0 },
    toggleLevel(level) {
      const i = this.selectedLevels.indexOf(level)
      if (i >= 0) this.selectedLevels.splice(i, 1)
      else this.selectedLevels.push(level)
      this.persistSettings()
    },
    toggleSub(s) {
      s.subscribed = !s.subscribed
      this.persistSettings()
      this.$message.success(s.subscribed ? '已订阅' : '已取消订阅')
    },
    openPrivacy() { this.privacyShow = true },
    changePwd() {
      if (!this.pwdForm.old) return this.$message.warning('请输入当前密码')
      if (!/^(?=.*[A-Za-z])(?=.*\d).{6,20}$/.test(this.pwdForm.new)) return this.$message.warning('新密码需包含字母+数字，6-20位')
      if (this.pwdForm.new !== this.pwdForm.confirm) return this.$message.warning('两次密码不一致')
      this.pwdSaving = true
      setTimeout(() => {
        this.pwdSaving = false
        this.pwdShow = false
        this.resetPwd()
        this.$message.success('密码已修改（前端演示）')
      }, 600)
    },
    resetPwd() { this.pwdForm = { old: '', new: '', confirm: '' } },
    switchTab(name) { this.tab = name },
    jumpToAnchor(id) {
      this.$nextTick(() => {
        const el = document.getElementById(id)
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    },
    doLogout() {
      this.logoutShow = false
      this.$store.dispatch('logout')
      this.$router.push('/login')
    },
    loadStats() {
      // 简化：直接走已有数据
      this.stats.bound = 0
      this.stats.alertToday = 0
      this.stats.onlineRate = 0
    }
  }
}
</script>

<style scoped>
.mine-page { padding: 20px !important; }

/* ============ 顶部 profile 卡片 ============ */
.profile-card { position: relative; border-radius: 16px; overflow: hidden; margin-bottom: 16px; box-shadow: 0 8px 24px rgba(22,93,255,0.10); background: #fff; }
.profile-bg { position: absolute; top: 0; left: 0; right: 0; height: 80px; background: linear-gradient(135deg, #165DFF, #4080FF); }
.profile-body { position: relative; display: flex; align-items: center; gap: 18px; padding: 30px 24px 24px; }
.avatar-box { flex-shrink: 0; }
.profile-meta { flex: 1; min-width: 0; }
.name-row { display: flex; align-items: center; gap: 8px; margin-bottom: 8px; flex-wrap: wrap; }
.profile-name { font-size: 18px; font-weight: 700; color: #fff; text-shadow: 0 1px 2px rgba(0,0,0,0.08); }
.profile-sub { font-size: 13px; color: rgba(255,255,255,0.85); display: flex; align-items: center; gap: 6px; }
.profile-sub .divider { color: rgba(255,255,255,0.45); }
.profile-edit { background: rgba(255,255,255,0.18) !important; color: #fff !important; border-color: rgba(255,255,255,0.3) !important; }

/* ============ 统计卡 ============ */
.stat-row { display: flex; gap: 16px; margin-bottom: 18px; }
.stat-card { flex: 1; background: #fff; border-radius: 12px; border: 1px solid #E5E6EB; box-shadow: 0 1px 2px rgba(16,24,40,0.04), 0 4px 12px rgba(16,24,40,0.05); padding: 18px 20px; text-align: center; }
.sc-num { font-size: 26px; font-weight: 700; line-height: 1.1; }
.sc-label { font-size: 13px; color: #86909c; margin-top: 4px; }

/* ============ Tabs ============ */
.mine-tabs { background: #fff; border-radius: 12px; border: 1px solid #E5E6EB; box-shadow: 0 1px 2px rgba(16,24,40,0.04), 0 4px 12px rgba(16,24,40,0.05); padding: 8px 16px 16px; }
.toolbar { margin: 8px 0 14px; display: flex; align-items: center; gap: 12px; }
.hint { color: #86909c; font-size: 12px; }
.self-tip { color: #c9cdd4; font-size: 13px; }
.ent-form { max-width: 560px; margin-top: 10px; }

/* ============ 设置 tab ============ */
.settings-wrap { padding: 10px 4px; }
.set-section { margin-bottom: 22px; }
.set-section-title {
  display: flex; align-items: center; gap: 8px;
  font-size: 14px; font-weight: 600; color: #1D2129;
  margin-bottom: 10px; padding-left: 4px;
}
.set-section-title i { color: #165DFF; font-size: 16px; }
.set-section-sub { font-size: 12px; color: #86909c; font-weight: normal; margin-left: auto; }

.set-card { background: #fff; border-radius: 12px; border: 1px solid #E5E6EB; box-shadow: 0 1px 2px rgba(16,24,40,0.04); overflow: hidden; }
.set-row {
  display: flex; align-items: center; gap: 14px;
  padding: 14px 18px; border-bottom: 1px solid #F2F3F5;
  font-size: 14px; color: #1D2129;
}
.set-row:last-child { border-bottom: none; }
.set-row.clickable { cursor: pointer; transition: background 0.2s ease; }
.set-row.clickable:hover { background: #FAFBFD; }
.set-label { width: 90px; flex-shrink: 0; color: #4E5969; }
.set-value { flex: 1; }
.set-value.muted { color: #86909C; }
.set-hint { color: #C9CDD4; font-size: 12px; }
.set-input { max-width: 360px; }
.set-arrow { color: #C9CDD4; font-size: 14px; }
.avatar-uploader { display: flex; align-items: center; }

/* 通知级别行 */
.lv-row { display: flex; align-items: center; gap: 14px; padding: 14px 18px; border-bottom: 1px solid #F2F3F5; cursor: pointer; transition: background 0.2s ease; }
.lv-row:last-child { border-bottom: none; }
.lv-row:hover { background: #FAFBFD; }
.lv-dot { width: 38px; height: 38px; border-radius: 10px; color: #fff; font-size: 13px; font-weight: 700; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.lv-meta { flex: 1; display: flex; flex-direction: column; gap: 3px; }
.lv-label { font-size: 14px; color: #1D2129; font-weight: 600; }
.lv-desc { font-size: 12px; color: #86909C; }
.lv-check { width: 22px; height: 22px; border-radius: 50%; border: 1.5px solid #C9CDD4; display: flex; align-items: center; justify-content: center; flex-shrink: 0; transition: all 0.2s ease; }
.lv-check.on { background: #165DFF; border-color: #165DFF; color: #fff; }

/* 订阅消息行 */
.sub-row { display: flex; align-items: center; gap: 14px; padding: 14px 18px; border-bottom: 1px solid #F2F3F5; }
.sub-row:last-child { border-bottom: none; }
.sub-meta { flex: 1; }
.sub-name { font-size: 14px; color: #1D2129; font-weight: 600; }
.sub-desc { font-size: 12px; color: #86909C; margin-top: 3px; }

/* 隐私政策 */
.privacy-text { font-size: 14px; color: #4E5969; line-height: 1.7; }
.privacy-text p { margin: 0 0 12px; }
.privacy-text ul { padding-left: 20px; margin: 0 0 12px; }
.privacy-text .muted { color: #86909C; font-size: 12px; }

/* 关于 */
.about { text-align: center; padding: 10px 0 0; }
.about-logo { width: 70px; height: 70px; border-radius: 16px; background: linear-gradient(135deg, #165DFF, #4080FF); display: flex; align-items: center; justify-content: center; color: #fff; font-size: 36px; margin: 0 auto 14px; box-shadow: 0 8px 20px rgba(22,93,255,0.30); }
.about-name { font-size: 18px; font-weight: 700; color: #1D2129; }
.about-text { font-size: 13px; color: #86909C; line-height: 1.6; margin: 8px 0 16px; }
.about-meta { font-size: 12px; color: #C9CDD4; margin-bottom: 16px; }
.about-btn { width: 100%; }
</style>
